"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodedError = void 0;
exports.getDocumentDisplayName = getDocumentDisplayName;
exports.assetToId = assetToId;
exports.assetToDisplayName = assetToDisplayName;
const types_1 = require("./types");
/**
 * Resolve a localization document's display name, preferring the new `display_name`
 * field and falling back to the legacy `human_id` for backward compatibility with
 * documents written before the rename.
 */
function getDocumentDisplayName(entry) {
    var _a;
    return (_a = entry === null || entry === void 0 ? void 0 : entry.display_name) !== null && _a !== void 0 ? _a : entry === null || entry === void 0 ? void 0 : entry.human_id;
}
function assetToId(asset) {
    // Handle deprecated asset.activity;
    if ('activity' in asset) {
        // eslint-disable-next-line no-param-reassign
        asset = {
            type: types_1.AssetTypes.ACTIVITY,
            id: asset.activity.identifier,
            version: '1_0',
        };
    }
    if (!('type' in asset && Object.values(types_1.AssetTypes).includes(asset.type))) {
        throw new CodedError('E_ASSET_NOT_SUPPORTED', 'Asset not supported');
    }
    if (!(asset.id && typeof asset.id === 'string' && asset.id.length > 0)) {
        throw new Error('Missing asset id');
    }
    const { type, id, version = 1 } = asset;
    let normalizedVersion = String(version);
    if (type === types_1.AssetTypes.ACTIVITY) {
        normalizedVersion = `1_0`;
    }
    return `${type}.${id}~${normalizedVersion}`;
}
function assetToDisplayName(asset) {
    // Handle deprecated asset.activity;
    if ('activity' in asset) {
        return asset.activity.short_name;
    }
    if (!('type' in asset && Object.values(types_1.AssetTypes).includes(asset.type))) {
        throw new CodedError('E_ASSET_NOT_SUPPORTED', 'Asset not supported');
    }
    return asset.human_id || asset.type;
}
class CodedError extends Error {
    constructor(code, message, metadata = {}) {
        super(message);
        this.code = code;
        this.metadata = metadata;
    }
}
exports.CodedError = CodedError;
//# sourceMappingURL=utils.js.map